(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    if (!window.__vyseraBackToTopInitialized) {
    window.__vyseraBackToTopInitialized = true;

    const backToTopButton = document.querySelector('[data-back-to-top]');
    const pageWrapper = document.querySelector('.page-wrapper');

    if (backToTopButton) {
      const getScrollPosition = () => {
        const windowScrollPosition = window.scrollY || window.pageYOffset || 0;
        const pageWrapperScrollPosition = pageWrapper?.scrollTop || 0;

        return Math.max(windowScrollPosition, pageWrapperScrollPosition);
      };

      const updateBackToTopVisibility = () => {
        backToTopButton.classList.toggle('is-visible', getScrollPosition() > 300);
      };

      window.addEventListener('scroll', updateBackToTopVisibility, { passive: true });
      pageWrapper?.addEventListener('scroll', updateBackToTopVisibility, { passive: true });
      window.addEventListener('resize', updateBackToTopVisibility, { passive: true });
      updateBackToTopVisibility();

      backToTopButton.addEventListener('click', () => {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const scrollOptions = { top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' };

        window.scrollTo(scrollOptions);
        pageWrapper?.scrollTo(scrollOptions);
      });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["returns-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__vyseraReturnsModalBound) return;
    window.__vyseraReturnsModalBound = true;

    const getModal = () => document.getElementById('returns-modal');

    const bindModalLifecycle = (modal) => {
      if (modal.dataset.returnsLifecycleBound) return;

      modal.dataset.returnsLifecycleBound = 'true';
      const releaseScrollLock = () => document.documentElement.classList.remove('returns-modal-open');
      modal.addEventListener('cancel', releaseScrollLock);
      modal.addEventListener('close', releaseScrollLock);
    };

    const openModal = () => {
      const modal = getModal();
      if (!modal) return;

      bindModalLifecycle(modal);

      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }

      document.documentElement.classList.add('returns-modal-open');

      const firstField = modal.querySelector('input:not([type="hidden"]), select');
      if (firstField) {
        window.requestAnimationFrame(() => firstField.focus());
      }
    };

    const closeModal = () => {
      const modal = getModal();
      if (!modal) return;

      if (typeof modal.close === 'function' && modal.open) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }

      document.documentElement.classList.remove('returns-modal-open');
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const trigger = target.closest('[data-returns-modal-open], a[href="#returns-modal"]');
      if (trigger) {
        event.preventDefault();
        openModal();
        return;
      }

      const closeButton = target.closest('[data-returns-modal-close]');
      if (closeButton) {
        event.preventDefault();
        closeModal();
        return;
      }

      const modal = getModal();
      if (modal && target === modal) {
        const bounds = modal.getBoundingClientRect();
        const clickedInside = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
        if (!clickedInside) closeModal();
      }
    });

    const openAfterFeedback = () => {
      const modal = getModal();
      if (modal && modal.querySelector('[data-returns-form-feedback]')) openModal();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openAfterFeedback, { once: true });
    } else {
      openAfterFeedback();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
